export default {"src":"/_next/static/media/RenewalClose.3da95e22.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};